<sb-split-button [menuItems]="menuItems"></sb-split-button>
